<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 m-10"> New Joining Employee</div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

 
    <ion-row>
      <ion-col size="12">
        <div class="modal-body p-7">
          <div class="mt-2">
            <div class="cardBox card">

              <div class="card  employeeTab">
                <div class="card-body">
                  <div>

                    <div>

                      <div class="table-container" style="overflow-x: auto; max-height: 400px; overflow-y: auto;">

                        <table class="custom-table rounded-header">

                          <thead>
                            <tr>

                              <th *ngFor="let item of  assetManagementHeader" class="fs-14 font_bold cl-black">
                                <div class="p-10 verticle-center justify-content-space-between icon-style">
                                  {{ item?.label }}
                                  <span *ngIf="item.isMandatory" class="red-cl">&nbsp;* </span>
                                  <div class="d-flex flex-column ml-10">

                                  </div>
                                </div>
                              </th>

                            </tr>
                          </thead>
                        
                          <tbody>
                            <tr *ngFor="let item of AllAssetListingData; let i = index">
                             
                              <td>{{item.employeeName}}</td>
                              <td>{{item.band}}
                                
                              </td>
                             
                              <td>
                                <!-- {{item.unassignedAssets}} -->
                                <ng-multiselect-dropdown 
                                [placeholder]="'Select Asset'" 
                                [settings]="dropdownSettings"
                                [data]="item.unassignedAssets" 
                                [(ngModel)]="selectedBandformultiple[i]" 
                                (ngModelChange)="updateAssetData(item)">
                              </ng-multiselect-dropdown>
                              <span *ngIf="!selecteAsset" style="color: red; font-size: 14;">Please select asset</span>

                              </td>
                              <td>{{ item.dateOfJoining | date: 'dd/MM/yyyy' }}</td>

                             <td>
                              <button class="back_btn fs-14" (click)="cancelData()">Cancel</button>
                              <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
                              (click)="updateDataByEmployee()">
                              Allocate Asset
                              </button>
                            </td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                      <div class="mt-20" style="font-weight: bold;">
                     {{AllAssetListingData.length}} entries
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <ion-row>

              </ion-row>
              <ion-row>






              </ion-row>



            </div>
          </div>

        </div>




      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="text-right mt-10">
        <button class="back_btn fs-14" (click)="cancelData()">Cancel</button>
       
      </ion-col>
    </ion-row>

  </div>
</div>